import SignInMfaPage from "./SignInMfaPage";

export default SignInMfaPage;
